import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "orion-no-saved" };
const _hoisted_2 = { class: "orion-no-saved__heading" };
const _hoisted_3 = { class: "orion-no-saved__text" };
const _hoisted_4 = { class: "orion-no-saved__buttons" };
const _hoisted_5 = {
    class: "orion-no-saved__btn orion-no-saved__btn--primary stat-button-link",
    "data-loc": "vehicle save header",
    href: "/searchall"
};
const _hoisted_6 = {
    class: "orion-no-saved__btn orion-no-saved__btn--secondary stat-button-link",
    "data-loc": "vehicle save header",
    href: "/searchnew"
};
const _hoisted_7 = {
    class: "orion-no-saved__btn orion-no-saved__btn--secondary stat-button-link",
    "data-loc": "vehicle save header",
    href: "/searchused"
};
const _hoisted_8 = { class: "orion-no-saved__info" };
const _hoisted_9 = { class: "orion-no-saved__info-title" };
const _hoisted_10 = { class: "orion-no-saved__info-body" };
import { computed } from "vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'orionNoSavedVehicles',
    props: {
        translations: {}
    },
    setup(__props) {
        const props = __props;
        const resources = computed(() => props.translations?.resources);
        const headingText = computed(() => resources.value?.["label_noSavedVehiclesYet"] || "No saved vehicles yet");
        const bodyText = computed(() => resources.value?.["comment_orionNoSavedVehiclesCopy"] ||
            "Tap the heart on any vehicle you like and we'll keep it here so you can easily compare, track price changes, and pick up where you left off.");
        const browseLabel = computed(() => resources.value?.["label_browseInventory"] || "Browse Inventory");
        const shopNewLabel = computed(() => `${resources.value?.["label_shop"] || "Shop"} ${resources.value?.["label_new"] || "New"}`);
        const shopUsedLabel = computed(() => `${resources.value?.["label_shop"] || "Shop"} ${resources.value?.["label_used"] || "Used"}`);
        const infoBoxes = computed(() => [
            {
                title: resources.value?.["label_quickAccess"] || "Quick access",
                body: resources.value?.["comment_quickAccess"] || "Jump back into the cars you're considering.",
            },
            {
                title: resources.value?.["label_compareSideBySide"] || "Compare side-by-side",
                body: resources.value?.["comment_compareSideBySide"] || "Stack saved vehicles to compare specs and price.",
            },
            {
                title: resources.value?.["label_trackPriceDrops"] || "Track price drops",
                body: resources.value?.["comment_trackPriceDrops"] || "Get notified when a saved vehicle drops in price.",
            },
        ]);
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _cache[1] || (_cache[1] = _createElementVNode("div", { class: "orion-no-saved__badge" }, [
                    _createElementVNode("i", {
                        "aria-hidden": "true",
                        class: "fa-regular fa-heart"
                    })
                ], -1 /* CACHED */)),
                _createElementVNode("h2", _hoisted_2, _toDisplayString(headingText.value), 1 /* TEXT */),
                _createElementVNode("p", _hoisted_3, _toDisplayString(bodyText.value), 1 /* TEXT */),
                _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("a", _hoisted_5, [
                        _cache[0] || (_cache[0] = _createElementVNode("i", {
                            "aria-hidden": "true",
                            class: "fa-solid fa-magnifying-glass"
                        }, null, -1 /* CACHED */)),
                        _createTextVNode(" " + _toDisplayString(browseLabel.value), 1 /* TEXT */)
                    ]),
                    _createElementVNode("a", _hoisted_6, _toDisplayString(shopNewLabel.value), 1 /* TEXT */),
                    _createElementVNode("a", _hoisted_7, _toDisplayString(shopUsedLabel.value), 1 /* TEXT */)
                ]),
                _createElementVNode("div", _hoisted_8, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(infoBoxes.value, (box) => {
                        return (_openBlock(), _createElementBlock("div", {
                            key: box.title,
                            class: "orion-no-saved__info-box"
                        }, [
                            _createElementVNode("p", _hoisted_9, _toDisplayString(box.title), 1 /* TEXT */),
                            _createElementVNode("p", _hoisted_10, _toDisplayString(box.body), 1 /* TEXT */)
                        ]));
                    }), 128 /* KEYED_FRAGMENT */))
                ])
            ]));
        };
    }
});
